<template>
    <div class="fuzzy-matching-box">
      <div v-if="titleValue == '学校组织管理'" class="zuzhibox">
        <div class="fuzzy-matching-top">
          <!-- <h1 class="titleStyle">学校组织管理</h1> -->
          <el-row class="top-first-line the-second-line">
            <el-col :span="7">
              <el-form-item label="名称:">
                <el-input v-model="Dform.schoolName" placeholder=''></el-input>
              </el-form-item>
            </el-col >
         
            <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
            <el-button type="primary" class="query-button" @click="AddClick">新增组织</el-button>
            <el-button type="primary" class="query-button" @click="daoRuClick">导入数据</el-button>
            <el-button type="primary" class="query-button" @click="deriveFamily">导出数据</el-button>
            <el-button type="primary" class="query-button" @click="downloadClick">下载模板</el-button>
          </el-row>
        </div>
        <div class="upload-box" v-if="formSourcesValue">
          <div class="upload-lef">
            <!-- <div @click="clickUpload">上传附件</div> -->
            <span class="upload-title">请选择要导入的数据文件：</span>
            <input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
            <el-button type="primary" @click="uploadClick">上传</el-button>
          </div>
        </div>
        <div class="fuzzy-matching-bottom">
            <el-table
            stripe
            :border="true"
            v-loading="loading"
            class="table-Style"
            :header-cell-style="{background:'#EDF6FF',color:'#000',}"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column
                prop="name"
                label="名称"
                >
              </el-table-column>
              <el-table-column
                prop="code"
                label="编号"
                >
              </el-table-column>
                <el-table-column
                prop="siId"
                label='SIID'
                >
              </el-table-column>
              <el-table-column
                prop="address"
                label="地址"
                >
              </el-table-column>
              <el-table-column
                label="操作"
                >
                <template #default="scope">
                <el-button type="text" size="small" class="greadStyle" @click="gradeManagement(scope.row)">二级组织管理</el-button>
                <el-button type="text" size="small"  class="greadStyle" @click="xiugaiClick(scope.row)" >修改</el-button>
                <el-button type="text" size="small"  class="deleteBtn" @click="deleteClick(scope.row)">删除</el-button>
              </template>
              </el-table-column>
              
            </el-table>
            <div class="block-fenye" >
              <el-pagination
                  layout="prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
            </div>
        </div>
      </div>
      <Add v-if="CardAddShow"  @AddShowClick="AddShowClick"  :xiugaiObj="xiugaiObj"></Add>

      <GradeManagement v-if="titleValue == '年级管理'" :gradeObj="gradeObj" @niajifanhui="niajifanhui"></GradeManagement>
    </div>
  </template>
  
  <script>
  import { schoolOrUserSchool ,} from '@/assets/api/renyuan';
  import {schoolInfodelete,importSchoolInfo,exportSchoolInfo } from '@/assets/api/schoollog'
  import { ElMessage } from 'element-plus'
  import  Add  from './AddSchool/add'
  import  GradeManagement  from './gradeManagement/index.vue'
  export default {
    components: {
      Add,
      GradeManagement
    },
    data() {
        return {
          CardAddShow:false,
          loading:true,
          Dform:{
            schoolName:""
          },
          tableData:[
            {
                title:'1111111'
            }
          ],
          pageInfo:{
            pageSize:"10",
            page:"1",
          },
          total:"",
          xiugaiObj:{},
          gradeObj:{},
          formSourcesValue: false,
          tempFile: "", //文件
          titleValue: '学校组织管理',
        };
    },
    created() {
      this.schoolOrUserListSearch()
    },
    mounted() {
  
    },
    methods: {
      //模板下载
      downloadClick(){
        window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/organizations.xls'
      },
      niajifanhui () {
        this.titleValue = '学校组织管理'
        this.schoolOrUserListSearch()
      },
      gradeManagement (item) {
        this.gradeObj = item
        this.titleValue = '年级管理'

      },
      // 导出
      deriveFamily () {
        exportSchoolInfo({ userId:JSON.parse(localStorage.getItem('user')).id, name: this.Dform.schoolName }).then((res)=> {
          console.log(res,'导出');
          this.handleExport(res.data,'Organizations.xls')
        }).catch((err)=> {

        })
      },
      handleExport(data,name) {
            // 动态创建iframe下载文件
            let fileName = name;
            if (!data) {
                return;
            }
            let blob = new Blob([data], { type: "application/octet-stream" });
            console.log(blob);
            if ("download" in document.createElement("a")) {
                // 不是IE浏览器
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 下载完成移除元素
                window.URL.revokeObjectURL(url); // 释放掉blob对象
            } else {
                // IE 10+
                window.navigator.msSaveBlob(blob, fileName);
            }
        },
      // 导入
      daoRuClick () {
        this.formSourcesValue = true
      },
      getFile(event) {
        this.tempFile = event.target.files[0];
      },
      // 上传
      uploadClick() {
            let index = this.tempFile.name.lastIndexOf(".");
            let fileName = this.tempFile.name.substr(index + 1);
            var filetypes = [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "doc",
                "ppt",
                "xls",
                "pdf",
                "docx",
                "xlsx",
            ];
            if (filetypes.includes(fileName)) {
                if (this.tempFile) {
                  let fileSize = this.tempFile.size / (1024 * 1024 * 60);
                  if (this.tempFile.name) {
                    let formData = new FormData();
                    console.log(formData,8888888);
                    formData.append("file", this.tempFile);
                    console.log(this.tempFile,formData.getAll('file'));
                    importSchoolInfo(formData,JSON.parse(localStorage.getItem('user')).id).then((res)=> {
                        console.log(res,'学校-导入');
                        ElMessage({message: '学校数据上传成功',type: 'success',})
                    }).catch((err)=> {
                        // console.log();
                        ElMessage.error("上传失败")
                    })
                  }
                }
            } else {
                ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
            }
            
        },
      //新增
      AddClick(){
        this.formSourcesValue = false
        this.CardAddShow = true
      },
      AddShowClick(){
        this.CardAddShow = false
        this.xiugaiObj = {}
        this.schoolOrUserListSearch()
      },
      // 修改
      xiugaiClick(item){
        this.CardAddShow = true
        this.xiugaiObj = item
      },
      //删除
      deleteClick(item){
        this.$confirm('确定删除该学校吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.deletereques(item)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }).catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
                    });

      },
      deletereques(item){
        const params = {
                  schoolId:item.id
            }
          schoolInfodelete(params).then((res) => {
          this.schoolOrUserListSearch()
          }).catch((err) => {
            // this.$message({
            //             type: 'error',
            //             message: err.response.data.msg
            //         });
          }) 
      },
     schoolOrUserListSearch(){
        const params = {
          schoolName:this.Dform.schoolName,
          page:this.pageInfo.page,
          pageSize:this.pageInfo.pageSize,
          userId:JSON.parse(localStorage.getItem('user')).id,
        }
        schoolOrUserSchool(params).then((res)=> {
            console.log(res,'学校组织管理');
            this.tableData = res.data.data.list
            this.total = res.data.data.total
            this.loading = false

        }).catch((err)=> {
          console.log(err,'学校组织管理失败');

        })
      },
      entrylogClick(){
        this.schoolOrUserListSearch()
      },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.page = val
      this.schoolOrUserListSearch()
    },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .fuzzy-matching-box {
    width: 100%;
    height:  96%;
    // background-color: #fff;
    .zuzhibox {
      height: 100%;
    }
   
    .fuzzy-matching-top {
        height: 100px ;
        background-color: #fff;
        // border-radius: 15px;
        display: flex;
        align-content: space-around;  
        align-items: center;
        .titleStyle{
          margin-left: 40px;
          font-size: 20px;
          font-weight: 700;
          width: 45%;
    }
      :deep() {
        .el-input--small .el-input__wrapper{
              margin-right: 15px;
              // border-radius: 15px
              ;
            }
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
          font-weight: 700;
        }
        .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
        .el-input {
          width: 180px;
          height: 35px;
        }
    }
    .the-second-line {
      margin-top: 15px;
      // position: relative;
      .query-button {
        padding: 16px 24px;
        // background-color: #1BC896;
        margin-left: 40px;
        border-radius: 15px;

      }
     
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }

  }
  .fuzzy-matching-content{
    height: 20px;
    line-height: 20px;
    margin-bottom: 10px;
    :deep() {
        .el-button{
            margin-left:50px;
            font-size: 16px;
            
        }
    }
  }
  .fuzzy-matching-bottom {
    height: 85%;
    overflow: auto;
    padding: 20px;
    padding-top: 30px;
    margin-top: 15px;
    border-radius: 15px;
    background-color: #fff;
    .table-Style{
      font-size: 16px;
      // border-radius: 15px;
    }
    .greadStyle{
      font-size: 15px;
      font-weight: 700;
      // color: #1BC896;

    }
    .deleteBtn{
      font-size: 15px;
      font-weight: 700;
      color: red;
    }
    :deep() {
      .el-table th.el-table__cell>.cell {
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
    }
    .el-table td.el-table__cell div{
      text-align: center;
      height: 40px;
      line-height: 40px;
      border: 0;
      font-size: 16px;
      color: black;
    }
    .el-table:not(.el-table--border) .el-table__cell{
      // border: 0;
    }
    .el-button--small {
        padding-left: 19px;
    }
  } 
}
.block-fenye{
  margin-left: 1000px;
  margin-top: 15px;
}
.upload-box {
    margin-top: 15px;
    .upload-lef {
        margin-left: 20px;
        font-size: 14px;
        .upload-title {}
    }
    .el-table tr {
        font-size: 20px;
    }
    :deep() {
        .el-table--enable-row-transition .el-table__body td.el-table__cell{
                    font-size: 40px;
        }
        // .el-form-item--small .el-form-item__content {
            //     height: 40px;
            //     line-height: 40px;
            // }
            .el-select .el-input__inner {
                height: 35px;
            }
            .el-form-item--small .el-form-item__label{
                margin-left: 20px;
                line-height: 35px;
            }
            
            .el-upload-list {
                // dis
                font-size: 80px;
            }
            
            
        }
    }
}
  </style>
